import { FC, ReactNode } from 'react'
import { Box, ButtonBase, Typography, useTheme } from '@mui/material'
import { BadgeColors } from './helpdesk.utils'

interface HelpdeskListRowProps {
  iconSlot: ReactNode
  title: string
  subtitle: string
  badgeLabel: string
  badgeColors: BadgeColors
  selected?: boolean
  showChevron?: boolean
  onClick: () => void
}

// List row used by the Helpdesk desktop master lists and mobile cards
// (Figma "Panel Klienta 3.0": ticket / reservation rows).
const HelpdeskListRow: FC<HelpdeskListRowProps> = ({
  iconSlot,
  title,
  subtitle,
  badgeLabel,
  badgeColors,
  selected,
  showChevron,
  onClick
}) => {
  const theme = useTheme()

  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        width: '100%',
        textAlign: 'left',
        padding: '18px 20px 19px 23px',
        backgroundColor: selected ? 'rgba(31, 31, 115, 0.04)' : '#fff',
        borderLeft: `3px solid ${selected ? theme.r4r.navy : 'transparent'}`,
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.06)',
        transition: 'background-color 0.2s',
        ':hover': {
          backgroundColor: selected ? 'rgba(31, 31, 115, 0.04)' : '#F9FAFB'
        }
      }}>
      {iconSlot}
      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '3px' }}>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 600,
            color: theme.r4r.ink,
            lineHeight: 'normal',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: '12px', color: theme.r4r.grey, lineHeight: 'normal' }}>
          {subtitle}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: badgeColors.backgroundColor,
          padding: '3px 10px',
          flexShrink: 0
        }}>
        <Typography
          sx={{
            color: badgeColors.color,
            fontSize: '11px',
            fontWeight: 700,
            lineHeight: 'normal',
            whiteSpace: 'nowrap'
          }}>
          {badgeLabel}
        </Typography>
      </Box>
      {showChevron && (
        <Typography sx={{ color: theme.r4r.greyLight, fontSize: '16px', pl: '4px' }}>›</Typography>
      )}
    </ButtonBase>
  )
}

export default HelpdeskListRow
